 $(document).ready(function() {

   $(".header.home_header .nav > ul > li > a").hover(function(e) {
      if ($(this).next("div").length) {
       $(".header.home_header").addClass("hovered");
      } else {
       $(".header.home_header").removeClass("hovered");
      }
   });

   $(".header.home_header").mouseleave(function(e) {
       $(this).removeClass("hovered");
   });

   $(".filter-group").click(function(e) {
      var attr = $(this).attr('open');
      if (typeof attr !== 'undefined' && attr !== false) {
         $(this).attr("open");
      } else {
         $(this).removeAttr("open");
      }
      $("details.filter-group").not($(this)).removeAttr("open");
   });

   $(".facet_mobile").click(function(e) {
       $("#shopify-section-facets").fadeIn().addClass("open");
   });

   $("#shopify-section-facets #close").click(function(e) {
       $("#shopify-section-facets").removeClass("open").fadeOut();
   });

    var selected = $("#ProductSelect-product-presentation option:selected").text();
   $("#ProductSelect-product-presentation").next("input").attr('value', selected);

   $("body").on("change", "#ProductSelect-product-presentation", function(){
      var selected = $("#ProductSelect-product-presentation option:selected").text();
      $("#ProductSelect-product-presentation").next("input").attr('value', selected);
   });

});
